export default __webpack_public_path__ + "img/tremors/tremors9_480.webp";